const prefixes = {
    number: '',
    currency: '$'
};

/**
 * These are "evil regexes", however, as they only run on the client side, it is not an issue for our node app.
 * @see: https://blog.liftsecurity.io/2014/11/03/regular-expression-dos-and-node.js/
 */
const maskRegexes = {
    // eslint-disable-next-line security/detect-unsafe-regex
    number: /\B(?=(\d{3})+(?!\d))/g,
    // eslint-disable-next-line security/detect-unsafe-regex
    currency: /\B(?=(\d{3})+(?!\d))/g
};

/**
 * Apply a mask to a value and return the new value
 * @param {String} value - The value to mask
 * @param {String} separator - The separator to use in the mask
 * @param {String} maskType - The type of mask to apply - num, tel, currency
 * @param {String} suffix - An optional suffix to add to the end of the masked value
 * @returns {String} - The value with the mask applied
 */
export const applyMask = (value, separator, maskType, suffix = '') => {
    const sanitizeRegex = /[^0-9.]+/g;
    const sanitizedValue = value.replace(sanitizeRegex, '');
    const maskedValue = `${prefixes[maskType]}${sanitizedValue.replace(maskRegexes[maskType], separator)}`;
    return suffix ? `${maskedValue} ${suffix}` : maskedValue;
};

export const masks = {
    number: (value, separator) => applyMask(value, separator, 'number'),
    currency: (value, separator) => applyMask(value, separator, 'currency'),
    kwh: (value, separator) => applyMask(value, separator, 'number', 'kWh'),
    mj: (value, separator) => applyMask(value, separator, 'number', 'MJ'),
    units: (value, separator) => applyMask(value, separator, 'number', 'Units')
};
